import { apiSlice } from "../../app/api/apiSlice";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // PRINTIFY ADMIN: Manually synchronize products from Printify.
    syncPrintifyProducts: builder.mutation({
      query: () => ({
        url: "/printify/sync",
        method: "POST",
      }),
      invalidatesTags: ["Product"],
    }),
    // 🔍 READ: Fetch All Products from /api/products
    getProducts: builder.query({
      query: () => "/product",
      providesTags: ["Product"],
    }),

    // ADMIN ONLY: Fetch complete product catalog.
    getAdminProducts: builder.query({
      query: () => "/product/admin/catalog",
      providesTags: ["Product"],
    }),

    // 🚀 CREATE: Send multi-image Form Data to /api/products
    createProduct: builder.mutation({
      query: (formData) => ({
        url: "/product",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Product"],
    }),

    // ✏️ UPDATE: Overwrite specific data logs at /api/products/:id
    updateProduct: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/product/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Product"],
    }),

    // 🗑️ DELETE: Purge product log from database arrays
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/product/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),

    // 🛠️ ADMIN WORKBENCH: Fetch ultra-lightweight inventory row names and variant IDs combo mapping
    getAdminInventoryList: builder.query({
      query: () => "/product/admin/inventory",
      providesTags: ["Product"], // Automatically re-fetches when stock counts shift
    }),

    // 📥 ADMIN STOCK BUMP: Add numerical unit quantities inside nested warehouse variant coordinates
    addVariantStockIncrement: builder.mutation({
      query: (stockPayload) => ({
        url: "/product/add-stock",
        method: "POST",
        body: stockPayload, // Expects { productId, variantId, amountToAdd }
      }),
      invalidatesTags: ["Product"], // Cleans cache out to force live layout rendering updates
    }),

    // PRINTIFY ADMIN: Edit product listing details and variant prices.
    updatePrintifyProductDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `/printify/products/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),

    // PRINTIFY ADMIN: Publish or unpublish a product.
    updatePrintifyPublication: builder.mutation({
      query: ({ id, isPublished }) => ({
        url: `/printify/products/${id}/publication`,
        method: "PATCH",
        body: { isPublished },
      }),
      invalidatesTags: ["Product"],
    }),
  }),
});

export const {
  useGetAdminProductsQuery,
  useSyncPrintifyProductsMutation,
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetAdminInventoryListQuery,
  useAddVariantStockIncrementMutation,
  useUpdatePrintifyProductDetailsMutation,
  useUpdatePrintifyPublicationMutation,
} = productApiSlice;
